import React from "react";
import { NavLink, useLocation } from "react-router-dom";

function ServiceSide() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
      <div className="prt-col-wrapper-bg-layer prt-bg-layer" />
      <aside className="widget widget-nav-menu with-title">
        <div className="widget-title">
          <h3>Our Services</h3>
        </div>
        <ul>
          <li
            className={
              currentPath === "/application-development" ? "active" : ""
            }
          >
            <NavLink to="/application-development">
              Application Development
            </NavLink>
          </li>
          <li
            className={
              currentPath === "/website-design-development" ? "active" : ""
            }
          >
            <NavLink to="/website-design-development">
              Web Design & Development
            </NavLink>
          </li>
          <li
            className={
              currentPath === "/mobile-application-development" ? "active" : ""
            }
          >
            <NavLink to="/mobile-application-development">
              Mobile Application Development
            </NavLink>
          </li>
          <li className={currentPath === "/digital-marketing" ? "active" : ""}>
            <NavLink to="/digital-marketing">Digital Marketing</NavLink>
          </li>
          <li className={currentPath === "/graphic-design" ? "active" : ""}>
            <NavLink to="/graphic-design">Graphic Design</NavLink>
          </li>
          <li
            className={currentPath === "/software-maintenance" ? "active" : ""}
          >
            <NavLink to="/software-maintenance">
              Software Maintenance & Support
            </NavLink>
          </li>
        </ul>
      </aside>
      <aside className="widget widget-banner with-title">
        <div className="prt-col-bgcolor-yes bg-base-dark text-base-white col-bg-img-four prt-col-bgimage-yes prt-bg">
          <div className="prt-col-wrapper-bg-layer prt-bg-layer bg-base-dark">
            <div className="prt-col-wrapper-bg-layer-inner bg-base-dark" />
          </div>
          <div className="layer-content text-center">
            <h3 className="sidebar-banner-heading">Moironix</h3>
            <div className="sidebar-banner-subheading">
              Need Help? We Are Here
              <br />
              To Help You
            </div>
            <a href="tel:1234567890" className="sidebar-banner-phone-link">
              +91 8328 473 790
            </a>
            <NavLink
              className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-gradiant"
              to="/contact"
            >
              Contact Us
            </NavLink>
          </div>
        </div>
      </aside>
    </>
  );
}

export default ServiceSide;
